var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 253,
    height: 29,
    viewBox: "0 0 253 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "metapark dark 1",
    clipPath: "url(#clip0_40_1170)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M76.6822 24.666C78.0182 24.666 79.2708 24.1308 79.8553 22.9194L85.5615 10.9468C85.6172 10.806 85.7842 10.7215 85.9234 10.7215C86.1461 10.7215 86.3688 10.8905 86.3688 11.2285V24.2716H91.212V10.3272C91.212 8.18614 90.5718 6.86212 89.4584 5.96066C88.6234 5.28456 87.5099 4.80566 86.1738 4.80566C83.7801 4.80566 82.3883 6.24236 81.4141 8.35517L77.1553 17.7078C77.044 17.9895 76.9049 18.074 76.6822 18.074C76.4595 18.074 76.3202 17.9895 76.209 17.7078L71.9502 8.35517C70.9759 6.24236 69.5842 4.80566 67.1904 4.80566C65.8543 4.80566 64.7409 5.28456 63.9059 5.96066C62.7925 6.86212 62.1523 8.18614 62.1523 10.3272V24.2716H66.9956V11.2285C66.9956 10.8905 67.2182 10.7215 67.4409 10.7215C67.5802 10.7215 67.7471 10.806 67.8028 10.9468L73.509 22.9194C74.0935 24.1308 75.3461 24.666 76.6822 24.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M96.5756 5.22852C94.7942 5.22852 93.9034 6.07363 93.9034 7.79205V21.6238C93.9034 23.3986 94.7942 24.2719 96.5478 24.2719H113.694V19.3983H99.3868C99.0807 19.3983 98.9418 19.2294 98.9418 18.8913V16.5813H113.61V12.9191H98.9418V10.75C98.9418 10.4401 99.0807 10.271 99.3868 10.271H113.694V5.22852H96.5756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M115.223 5.22852V10.271H123.49V24.2719H128.556V10.271H136.795V5.22852H115.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M151.659 8.327C150.602 5.96066 148.848 4.80566 146.231 4.80566C143.531 4.80566 141.834 5.96066 140.775 8.327L134.04 23.4264C133.9 23.7363 133.817 23.9899 133.734 24.2716H139.551C139.579 24.0462 139.662 23.8209 139.746 23.5955L140.721 21.3137H151.854L152.856 23.6237C152.939 23.8209 153.023 24.018 153.079 24.2716H158.757C158.674 23.9899 158.59 23.7363 158.451 23.4264L151.659 8.327ZM142.557 17.1162L145.425 10.2989C145.619 9.84821 145.925 9.70736 146.26 9.70736C146.622 9.70736 146.955 9.87638 147.122 10.2989L150.017 17.1162H142.557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M161.971 5.22852C161.164 5.22852 160.746 5.62291 160.746 6.41169V24.2719H165.784V19.4828H174.441C177.336 19.4828 179.256 18.4687 180.537 16.9194C181.566 15.6517 182.179 14.0459 182.179 12.3557C182.179 10.4401 181.4 8.609 180.092 7.28497C178.839 6.0173 177.113 5.22852 174.441 5.22852H161.971ZM165.784 14.8065V10.6655C165.784 10.3838 165.924 10.271 166.146 10.271H174.552C175.638 10.271 176.279 10.6091 176.695 11.1162C177.002 11.5106 177.168 11.9895 177.168 12.5529C177.168 13.0881 177.002 13.5388 176.724 13.905C176.306 14.4685 175.665 14.8065 174.552 14.8065H165.784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M197.979 8.327C196.92 5.96066 195.167 4.80566 192.551 4.80566C189.851 4.80566 188.153 5.96066 187.095 8.327L180.359 23.4264C180.22 23.7363 180.137 23.9899 180.052 24.2716H185.87C185.898 24.0462 185.982 23.8209 186.065 23.5955L187.039 21.3137H198.173L199.176 23.6237C199.259 23.8209 199.342 24.018 199.398 24.2716H205.077C204.993 23.9899 204.909 23.7363 204.771 23.4264L197.979 8.327ZM188.877 17.1162L191.743 10.2989C191.939 9.84821 192.245 9.70736 192.578 9.70736C192.94 9.70736 193.275 9.87638 193.441 10.2989L196.337 17.1162H188.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M212.103 17.5109H220.872C222.347 17.5109 222.931 17.9898 222.931 19.2012V23.0042C222.931 23.4267 222.959 23.8494 223.015 24.2719H228.109C228.053 23.7366 228.025 23.2859 228.025 22.4689V18.6659C228.025 16.4968 227.468 15.4826 226.215 14.722C227.551 13.7361 227.997 12.2993 227.997 10.7781C227.997 9.34143 227.413 8.01741 226.494 7.03143C225.464 5.93278 223.989 5.22852 221.679 5.22852H208.318C207.483 5.22852 207.065 5.62291 207.065 6.41169V24.2719H212.103V17.5109ZM212.103 13.1726V10.4119C212.103 10.1584 212.242 9.98935 212.521 9.98935H221.011C221.65 9.98935 222.096 10.1865 222.374 10.4964C222.653 10.7781 222.792 11.1725 222.792 11.5669C222.792 11.9331 222.653 12.2711 222.43 12.5529C222.124 12.9191 221.706 13.1726 221.011 13.1726H212.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M230.497 5.22852V24.2719H235.59V15.8488L244.609 23.4831C244.943 23.7648 245.221 24.0183 245.444 24.2719H252.96C252.737 24.0183 252.487 23.7929 252.236 23.5676L241.129 14.4685C240.991 14.3558 240.962 14.2995 240.962 14.1586C240.962 14.0178 241.018 13.9332 241.129 13.8487L251.484 5.73559C251.651 5.59474 251.874 5.39754 251.985 5.22852H244.943C244.748 5.48205 244.442 5.79193 244.164 6.0173L235.59 13.0318V5.22852H230.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M15.7893 0.458958C16.6506 -0.0442624 17.7116 -0.0442617 18.5728 0.458959L29.0763 6.59626C29.394 6.78193 29.805 6.78194 30.1228 6.59628L40.6263 0.458974C41.4874 -0.0442455 42.5485 -0.0442449 43.4097 0.458975L53.9132 6.59628C54.7744 7.0995 55.3049 8.02949 55.3049 9.03593V21.3106C55.3049 22.317 54.7744 23.2469 53.9132 23.7502L52.7487 24.4306C52.6763 24.473 52.5856 24.4171 52.5856 24.3324V12.5706C52.5856 11.2641 51.9149 10.0515 50.8144 9.36857L43.9041 5.0799C42.7421 4.35875 41.2831 4.34028 40.1035 5.03179L32.6828 9.3826C31.5371 10.0543 30.8318 11.2927 30.8318 12.6327V23.3359C30.8318 23.7041 30.4379 23.9343 30.1228 23.7502C29.805 23.5646 29.394 23.5645 29.0763 23.7501L28.7139 23.9619C28.5605 24.0516 28.3672 23.9252 28.3672 23.7459V12.693C28.3672 11.3758 27.6855 10.1549 26.5705 9.47537L19.1228 4.93626C17.9307 4.20972 16.4372 4.21915 15.2541 4.96068L8.06145 9.46899C6.96896 10.1538 6.30422 11.3617 6.30422 12.6622V23.777C6.30422 24.0166 6.04433 24.1934 5.83926 24.0735L5.28591 23.7501C4.42469 23.2469 3.89417 22.317 3.89417 21.3105V9.03591C3.89417 8.02948 4.42469 7.09949 5.28591 6.59626L15.7893 0.458958Z",
    fill: "url(#paint0_linear_40_1170)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.4,
    d: "M17.1865 3.64844L28.6101 10.2728V23.4341L18.8992 28.5466C17.8257 29.1118 16.5473 29.1118 15.4738 28.5465L5.76306 23.4341V10.2728L17.1865 3.64844Z",
    fill: "url(#paint1_linear_40_1170)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.6,
    d: "M42.0777 3.64844L53.6214 10.3187V23.5714L43.7455 28.5992C42.6962 29.1333 41.4591 29.1333 40.4098 28.5992L30.5339 23.5714V10.3187L42.0777 3.64844Z",
    fill: "url(#paint2_linear_40_1170)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M29.9288 19.6331C45.0305 17.3065 56.7801 11.6791 56.1723 7.06397C56.1106 6.59559 55.924 6.15564 55.6227 5.74561C56.4943 6.3883 57.0228 7.13044 57.1507 7.96428C57.8681 12.6463 45.6772 18.4464 29.9216 20.9192C14.166 23.392 0.811977 21.601 0.0945612 16.9191C-0.113448 15.5615 0.763699 14.11 2.49827 12.6729C1.72536 13.6291 1.36429 14.579 1.48421 15.4895C2.09201 20.1045 14.8271 21.9597 29.9288 19.6331Z",
    fill: "url(#paint3_linear_40_1170)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40_1170",
    x1: 3.90731,
    y1: 7.63325,
    x2: 56.7058,
    y2: 26.2206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474158,
    stopColor: "#EEA923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_40_1170",
    x1: 5.70892,
    y1: 16.2868,
    x2: 28.6641,
    y2: 16.2868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ACFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.104621,
    stopColor: "#1ECCE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225809,
    stopColor: "#33C8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364309,
    stopColor: "#4AC4BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499347,
    stopColor: "#09A278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644772,
    stopColor: "#85BA83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783273,
    stopColor: "#A7B464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.897535,
    stopColor: "#BCB150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0AB2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_40_1170",
    x1: 30.4792,
    y1: 16.3745,
    x2: 53.6761,
    y2: 16.3745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.104621,
    stopColor: "#EBA32A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225809,
    stopColor: "#E59B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364309,
    stopColor: "#DE8E4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499347,
    stopColor: "#BE5928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644772,
    stopColor: "#CC7079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783273,
    stopColor: "#C15D97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.897535,
    stopColor: "#BA51A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B143C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_40_1170",
    x1: 24.4611,
    y1: 17.9945,
    x2: 63.6849,
    y2: 4.51405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_1170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 253,
    height: 29,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterlogo);
export default __webpack_public_path__ + "static/media/footerlogo.2866b7d094d5c05194cf4fc9d4ff1b34.svg";
export { ForwardRef as ReactComponent };